module.exports = __webpack_public_path__ + "static/media/disabled-folder-dark.ff600043.svg";